import moment from "moment";

import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LightPrivateBill } from "@/Patient/Api/PrivateBill/Dto/LightPrivateBill";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

interface IReusingPrivateBillPopupProps {
    onCloseCallback: () => void;
    NoteModel: IPatientMedicalNoteModel;
}

class ReusingPrivateBillPopupState { }

class ReusingPrivateBillPopup extends React.Component<IReusingPrivateBillPopupProps, ReusingPrivateBillPopupState> {
    private id = "reusingprivatebillpopup";

    public componentDidMount(): void {
        var elem = $("#" + this.id);
        var cnt = document.body;
        var dragOptions = {
            containment: cnt,
            handle: ".p-header"
        };
        elem.draggable(dragOptions);
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();

        const elem = $("#" + this.id);
        elem.draggable("destroy");
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    public render(): JSX.Element {
        return (
            <div
                id={this.id}
                onClick={this.stopPropagation.bind(this)}
                className="request-popup reuse-private-bill-popup-container ui-draggable"
            >
                <div className="p-header">
                    <div className="flex-container">
                        <div>
                            <h3>{cacheStore.GetString("ReuseABillLabel")}</h3>
                        </div>
                        <div className="flex-container" style={{ justifyContent: "flex-end" }}>
                            <a className="close" onClick={() => this.props.onCloseCallback()} aria-label="Close">x</a>
                        </div>
                    </div>
                </div>

                <div className="private-billing">
                    <div
                        className="flex-container"
                        style={{ justifyContent: "flex-start", alignItems: "stretch" }}
                    >
                        {this.LeftSide()}
                        {this.RightSide()}
                    </div>
                </div>

                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-9 col-md-9 col-sm-9">
                            {/* this.state.isLoading && <img src={img_loading} alt="loading" /> */}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 text-right">
                            <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                                <div>
                                    <button
                                        className="btn btn-default push-right-5"
                                        onClick={() => this.props.onCloseCallback()}
                                    >
                                        {cacheStore.GetString("CloseLabel")}
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        disabled={IsNullOrWhiteSpace(this.props.NoteModel.get("SelectedReusedPrivateBillId"))}
                                        onClick={() => this.onContinueClick()}
                                        data-cy="reusingPrivateBill-continue"
                                    >
                                        {cacheStore.GetString("ContinueLabel")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private LeftSide(): JSX.Element {
        var self = this;

        return (
            <div className="fxheight tbc full-border left-primary private-bill-list-container">
                <div className="note-search">
                    <div className="header" />
                    <div className="search-field">
                        <div className="gf">
                            <span className="glyphicon glyphicon-search" />
                        </div>
                        <TextboxControl debounceMs={400} value={self.props.NoteModel.get("ReusingPrivateBillSearchText")} className="fullWidth" operation={LocalPatientOperations.MedicalNote.ReusingPrivateBillSearchText} placeholder={cacheStore.GetString("SearchLabel")} />
                    </div>
                    {self.props.NoteModel.get("ShowReusingPrivateBillCriteria") === true && (
                        <div style={{ marginTop: "10px" }}>
                            <MultiDateSelector
                                id="doc_search_date_selector"
                                fullWidth={true}
                                fromMyleOperation={LocalPatientOperations.MedicalNote.ReusingPrivateBillFromDateChange}
                                toMyleOperation={LocalPatientOperations.MedicalNote.ReusingPrivateBillToDateChange}
                                fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                from={self.props.NoteModel.get("ReusingPrivateBillCriteriaFrom")}
                                to={self.props.NoteModel.get("ReusingPrivateBillCriteriaTo")}
                            />
                        </div>
                    )}
                    <div className="clearfix" style={{ marginTop: "15px" }}>
                        {self.props.NoteModel.get("ShowReusingPrivateBillCriteria") === false &&
                            <a className="pull-right" onClick={this.showCriteria.bind(this)}>[+]{cacheStore.GetString("CriteriaLabel")}</a>
                        }
                        {self.props.NoteModel.get("ShowReusingPrivateBillCriteria") === true &&
                            <a className="pull-right" onClick={this.showCriteria.bind(this)}>[-]{cacheStore.GetString("CriteriaLabel")}</a>
                        }
                    </div>
                </div>
                {self.RenderPrivateBillList()}
            </div>
        );
    }

    private RenderPrivateBillList(): JSX.Element {
        const privateBillList = this.props?.NoteModel?.get("ReusingPrivateBillsList")?.toArray();
        let privateBillRender = null;

        privateBillRender = isArrayNullOrUndefinedOrEmpty(privateBillList) ? this.renderEmptyPrivateList() : this.renderPrivateList(privateBillList);

        return (
            <div className="note-collection scrollable position-relative reusing-private-bill" data-cy="reusingPrivateBill-billItems">
                {privateBillRender}
            </div>
        );
    }

    private renderEmptyPrivateList(): JSX.Element {
        return (
            <div className="empty-private-list-container">
                <span>{cacheStore.GetString("NoBillsLabel")}</span>
            </div>
        );
    }

    private renderPrivateList(privateBillList: LightPrivateBill[]): JSX.Element {
        const selectedReusedPrivateBillId = this.props.NoteModel?.get("SelectedReusedPrivateBillId") ?? null;

        return (
            <>
                {privateBillList.map((item: LightPrivateBill, idx: number) => {
                    const provider = cacheStore.GetEmployeeByContactFacetId(item.ProviderId);
                    const providerTitle = cacheStore.GetLocalizedValueByLookupId(provider.PrefixLookupId);

                    const createdBy = cacheStore.GetEmployeeByContactFacetId(item.CreatedById);
                    const createdByTitle = cacheStore.GetLocalizedValueByLookupId(createdBy.PrefixLookupId);

                    const isSelected = selectedReusedPrivateBillId === item.PrivateBillId;
                    const selectedClass = isSelected ? "med-note selected" : "med-note";

                    if (item.IsInvalid) {
                        return (
                            <div className="pointer" onClick={this.onSelectPrivateBill.bind(this, item.PrivateBillId)} key={"item_" + idx}>
                                <div className={selectedClass}>
                                    <div className="tb">
                                        <div className="flex-container">
                                            <p style={{ color: "red" }}><strong>{providerTitle + " " + provider.LastName + ", " + provider.FirstName}</strong></p>
                                            <p style={{ color: "red" }}><span>{moment(item.BillDate).format("YYYY/MM/DD hh:mm:ss")}</span></p>
                                        </div>
                                        <div className="flex-container">
                                            <p style={{ color: "red" }}><span>{cacheStore.GetString("BilledByLabel")} {createdByTitle + " " + createdBy.LastName + ", " + createdBy.FirstName}</span></p>
                                        </div>
                                        <div className="flex-container">
                                            <p style={{ color: "red" }}><span>#{item.Number}</span></p>
                                            <p style={{ color: "red" }}><span>$ {item.BillTotal.toFixed(2)}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                    else {
                        return (
                            <div className="pointer" onClick={this.onSelectPrivateBill.bind(this, item.PrivateBillId)} key={"item_" + idx}>
                                <div className={selectedClass}>
                                    <div className="tb">
                                        <div className="flex-container">
                                            <p><strong>{providerTitle + " " + provider.LastName + ", " + provider.FirstName}</strong></p>
                                            <p><span>{moment(item.BillDate).format("YYYY/MM/DD hh:mm:ss")}</span></p>
                                        </div>
                                        <div className="flex-container">
                                            <p><span>{cacheStore.GetString("BilledByLabel")} {createdByTitle + " " + createdBy.LastName + ", " + createdBy.FirstName}</span></p>
                                        </div>
                                        <div className="flex-container">
                                            <p><span>#{item.Number}</span></p>
                                            <p><span>$ {item.BillTotal.toFixed(2)}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                })}
            </>
        );
    }

    private RightSide(): JSX.Element {
        const url = apiSettings.buildAppUrl(
            `api/pdf/fetch/${this.props.NoteModel.get("SelectedReusedPrivateBillFileName")}.pdf`,
            {
                auth: true,
                hash: "toolbar=0&zoom=80"
            }
        );

        return (
            <div className="width-85">
                {!IsNullOrWhiteSpace(this.props.NoteModel.get("SelectedReusedPrivateBillFileName")) &&
                    <iframe id="reusedPrivateBillPdfViewer" src={url} className="w-h-100" />
                }
            </div>
        );
    }

    private showCriteria(): void {
        LocalEvent.Dispatch(LocalPatientOperations.MedicalNote.ShowReusingPrivateBillCriteria);
    }

    private onSelectPrivateBill(privateBillId: string): void {
        var op = new LocalEvent(LocalPatientOperations.MedicalNote.SelectReusingPrivateBillClick);
        op.AddItem("privateBillId", privateBillId);
        LocalEventDispatcher.dispatch(op);
    }

    private onContinueClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.MedicalNote.ReusingContinueClick);
    }
}

export { ReusingPrivateBillPopup };
